<template>
  <div class="student-detail-container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>学员详情</p>
      </div>
      <div class="right">
        <integral-dialog
          :student-id="Number($route.query.id)"
          @change="getDetails"
          v-if="detailsData.status == 2"
        >
          <div class="mwow-button success">积分</div>
        </integral-dialog>
        <div
          class="mwow-button success"
          v-if="detailsData.status == 3"
          @click="convertIntention(detailsData)"
        >
          转回意向
        </div>
        <!-- :class="`mwow-button ${ buttonAuth.pay ? 'primary' : 'disable
              not-allowed' }`" -->
        <div
          :class="`mwow-button ${
            buttonAuth.pay ? 'success' : 'disable not-allowed'
          }`"
          @click="clickrenew"
          v-if="detailsData.is_recycle == 2"
        >
          缴费
        </div>
        <div
          :class="`mwow-button ${
            buttonAuth.follow ? 'success' : 'disable not-allowed'
          }`"
          @click="followContent"
        >
          跟进
        </div>
        <editStudentDialog
          :student-info="detailsData"
          @recovery="recoveryPost"
          v-if="buttonAuth.edit"
        >
          <div class="mwow-button success">编辑</div>
        </editStudentDialog>
        <div v-if="!buttonAuth.edit" class="mwow-button disable not-allowed">
          编辑
        </div>
        <recoveryDialog
          :studentInfo="detailsData"
          @recovery="recoveryPost"
          v-if="
            detailsData.status == 1 &&
            detailsData.is_recycle == 2 &&
            buttonAuth.recycle
          "
        >
          <div class="mwow-button success">回收</div>
        </recoveryDialog>
        <div
          v-if="
            detailsData.status == 1 &&
            detailsData.is_recycle == 2 &&
            !buttonAuth.recycle
          "
          class="mwow-button disable not-allowed"
        >
          回收
        </div>
        <div
          class="mwow-button success"
          v-if="detailsData.is_recycle == 1"
          @click="handleRecover"
        >
          还原
        </div>
        <div
          class="mwow-button info"
          v-if="detailsData.status == 2"
          @click="poststudentCompletion(detailsData)"
        >
          结业
        </div>
        <div
          class="mwow-button success"
          @click="delDetails"
          v-if="
            (detailsData.status == 3 || detailsData.is_recycle == 1) &&
            $route.query.from !== 'history'
          "
        >
          删除
        </div>
        <div
          class="mwow-button success"
          v-if="
            detailsData.status === 1 &&
            detailsData.follow_staff_name &&
            currentStaffID === detailsData.follow_staff_id
          "
          @click="handleCancelFollow"
        >
          放弃学员
        </div>
      </div>
    </div>
    <div class="student-info-block">
      <div class="block-left">
        <div class="family-info" :class="{ collapse: familyInfoCollapse }">
          <span class="mobile">家庭主号：{{ familyMobile }}</span>
          <div class="name-wrap" ref="familyInfoEl">
            <span
              class="name"
              :class="{
                active: Number($route.query.id) === Number(item.student_id),
              }"
              v-for="item in familyMemberList"
              :key="item.student_id"
              @click="toStudentDetail(item.student_id)"
              >{{ item.name }}</span
            >
          </div>
          <span
            class="more"
            @click="handleToggleFamilyInfo"
            v-show="familyInfoToggleVisible"
          >
            <i class="el-icon-arrow-down" v-show="familyInfoCollapse"></i>
            <i class="el-icon-arrow-up" v-show="!familyInfoCollapse"></i>
          </span>
        </div>
        <div class="student-info">
          <div class="main-wrap">
            <div class="avatar-wrap">
              <div class="avatar">
                <el-popover
                  placement="right"
                  trigger="hover"
                  v-show="detailsData.avatar_url"
                >
                  <img height="240" :src="detailsData.source_avatar_url" />
                  <a
                    :href="detailsData.source_avatar_url"
                    slot="reference"
                    target="_blank"
                    style="
                      display: inline-block;
                      width: 70px;
                      height: 70px;
                      border-radius: 50%;
                      overflow: hidden;
                      border: 1px solid #e7e8ea;
                    "
                  >
                    <el-image
                      style="width: 70px; height: 70px"
                      fit="cover"
                      :src="detailsData.avatar_url"
                    />
                  </a>
                </el-popover>
              </div>
              <div class="tag">
                <div
                  class="mwow-tag warning-filled"
                  v-if="detailsData.status == 1"
                >
                  意向
                </div>
                <div
                  class="mwow-tag success-filled"
                  v-if="detailsData.status == 2"
                >
                  在读
                </div>
                <div
                  class="mwow-tag danger-filled"
                  v-if="detailsData.status == 3"
                >
                  历史
                </div>
              </div>
            </div>
            <div class="form">
              <div class="row">
                <p class="item">
                  <span class="label">{{ detailsData.name }}</span>
                  <span class="line"></span>
                  <span v-if="detailsData.sex === 1">男</span>
                  <span v-else-if="detailsData.sex === 2">女</span>
                  <span v-else>-</span>
                </p>
                <p class="item">
                  <span class="label">{{
                    mobileRelation[detailsData.mobile_relation]
                  }}</span>
                  <span class="line"></span>
                  <span>
                    {{
                      detailsData.area_code && detailsData.mobile
                        ? "+" + detailsData.area_code
                        : ""
                    }}
                    {{
                      detailsData.mobile.slice(0, 3) +
                      "-" +
                      detailsData.mobile.slice(3, 7) +
                      "-" +
                      detailsData.mobile.slice(7)
                    }}
                    {{
                      detailsData.wechat && detailsData.mobile
                        ? "/ " + detailsData.wechat
                        : detailsData.wechat
                    }}
                  </span>
                </p>
              </div>
              <div class="row">
                <p class="item">
                  <span class="label">出生日期：</span>
                  <span>{{ detailsData.birthdaydate || "-" }}</span>
                  <span v-if="detailsData.birthday" class="line"></span>
                  <span v-if="detailsData.birthday"
                    >{{ detailsData.age }}
                  </span>
                </p>
                <p class="item">
                  <span class="label">监护人：</span>
                  <span>{{
                    guardianRelationList[Number(detailsData.guardian_relation)]
                  }}</span>
                  <span class="line"></span>
                  <span>
                    {{
                      detailsData.guardian_mobile &&
                      detailsData.guardian_area_code
                        ? "+" + detailsData.guardian_area_code
                        : ""
                    }}
                    <span v-if="detailsData.guardian_mobile">{{
                      detailsData.guardian_mobile.slice(0, 3) +
                      "-" +
                      detailsData.guardian_mobile.slice(3, 7) +
                      "-" +
                      detailsData.guardian_mobile.slice(7)
                    }}</span>
                    <span v-else>-</span>
                  </span>
                </p>
              </div>
              <div class="row">
                <p class="item">
                  <span class="label">就读学校：</span>
                  <span>{{ detailsData.school || "-" }}</span>
                </p>
              </div>
              <div class="row">
                <p class="item">
                  <span class="label">家庭地址：</span>
                  <span>{{ detailsData.home_address || "-" }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="other-wrap">
            <div class="row">
              <p class="item">
                <span class="label">出现方式：</span>
                <span>{{ detailsData.appear_name }}</span>
              </p>
              <p class="item">
                <span class="label">累计获得：</span>
                <span>{{
                  detailsData.integral ? detailsData.integral.historical : "-"
                }}</span>
              </p>
              <p class="item">
                <span class="label">教务老师：</span>
                <span>{{
                  detailsData.teacher_name ? detailsData.teacher_name : "-"
                }}</span>
              </p>
              <p class="item" v-if="detailsData.status === 3">
                <span class="label">结业分类：</span>
                <span>
                  <span v-if="detailsData.completion_category_id === 1"
                    >距离远</span
                  >
                  <span v-if="detailsData.completion_category_id === 2"
                    >不感兴趣</span
                  >
                  <span v-if="detailsData.completion_category_id === 3"
                    >价格贵</span
                  >
                  <span v-if="detailsData.completion_category_id === 4"
                    >时间不合适</span
                  >
                  <span v-if="detailsData.completion_category_id === 5"
                    >艺考</span
                  >
                  <span v-if="detailsData.completion_category_id === 6"
                    >学业忙/工作忙</span
                  >
                </span>
              </p>
              <p
                class="item"
                v-if="detailsData.status === 1 && detailsData.is_recycle === 1"
              >
                <span class="label">回收分类：</span>
                <span v-if="detailsData.recycle_category_id === 1"
                  >多次未接</span
                >
                <span v-if="detailsData.recycle_category_id === 2"
                  >距离超过3公里</span
                >
                <span v-if="detailsData.recycle_category_id === 3">没意向</span>
                <span v-if="detailsData.recycle_category_id === 4"
                  >年龄不到3岁</span
                >
              </p>
            </div>
            <div class="row">
              <p class="item">
                <span class="label">意向科目：</span>
                <span
                  v-if="
                    detailsData.student_subject &&
                    detailsData.student_subject.length > 0
                  "
                >
                  <span
                    v-for="(item, index) in detailsData.student_subject"
                    :key="index"
                    class="text-color font-size-14"
                  >
                    {{
                      index == detailsData.student_subject.length - 1
                        ? item.subject_title
                        : item.subject_title + ","
                    }}
                  </span>
                </span>
                <span v-else>-</span>
              </p>
              <p class="item">
                <span class="label">有效积分：</span>
                <span>{{
                  detailsData.integral ? detailsData.integral.usable : "-"
                }}</span>
              </p>
              <p class="item">
                <span class="label">课程顾问：</span>
                <span>{{
                  detailsData.follow_staff_name
                    ? detailsData.follow_staff_name
                    : "-"
                }}</span>
              </p>
              <p class="item" v-if="detailsData.status === 3">
                <span class="label">结业原因：</span>
                <span>{{
                  detailsData.completion_remark
                    ? detailsData.completion_remark
                    : "-"
                }}</span>
              </p>
              <p
                class="item"
                v-if="detailsData.status === 1 && detailsData.is_recycle === 1"
              >
                <span class="label">回收原因：</span>
                <span>
                  {{
                    detailsData.recycle_remark
                      ? detailsData.recycle_remark
                      : "-"
                  }}
                </span>
              </p>
            </div>
            <div class="row">
              <p class="item">
                <span class="label">来源渠道：</span>
                <span>{{
                  detailsData.student_source
                    ? detailsData.student_source.name
                    : "-"
                }}</span>
              </p>
              <p class="item">
                <span class="label">冻结积分：</span>
                <span>{{
                  detailsData.integral ? detailsData.integral.freeze : "-"
                }}</span>
              </p>
              <p class="item">
                <span class="label">市场顾问：</span>
                <span>{{
                  detailsData.market_staff ? detailsData.market_staff.name : "-"
                }}</span>
              </p>
              <!-- 占位 -->
              <p class="item" v-if="detailsData.status === 3"></p>
              <!-- 占位 -->
              <p
                class="item"
                v-if="detailsData.status === 1 && detailsData.is_recycle === 1"
              ></p>
            </div>
            <div class="row">
              <p class="item">
                <span class="label">备注：</span>
                <span>{{ detailsData.remark ? detailsData.remark : "-" }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-right">
        <p class="title">里程碑</p>
        <div class="list">
          <div
            :class="`step${item.milestone_date ? ' active' : ''}`"
            v-for="(item, index) in milestoneList"
            :key="item.milestone_stage"
          >
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/student/check.png"
              class="icon"
              v-if="item.milestone_date"
            />
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/student/step.png"
              class="icon"
              v-else
            />
            <span
              class="line"
              :class="{ active: item.milestone_date }"
              v-if="index !== 0"
            >
            </span>
            <div class="flex text-wrap">
              <p class="text bold">
                {{ milestoneLabel[item.milestone_stage] }}
              </p>
              <p class="text">{{ item.milestone_date || "未完成" }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs-wrap">
      <el-tabs v-model="activeName" @tab-click="handleTabChange">
        <!-- 已购课程 -->
        <el-tab-pane
          :key="initTab1"
          label="已购课程"
          name="purchased"
          v-if="detailsData.is_recycle == 2"
        >
          <purchased-course
            :sid="id"
            :detailsData="detailsData"
            :visible="activeName === 'purchased'"
          >
          </purchased-course>
        </el-tab-pane>
        <!-- 已点名课时 -->
        <el-tab-pane
          :key="initTab2"
          label="已点名课时"
          name="rollcall"
          class="rollcall"
          v-if="detailsData.is_recycle == 2"
        >
          <already-roll-call :sid="id" :visible="activeName === 'rollcall'">
          </already-roll-call>
        </el-tab-pane>
        <!-- 待点名课时 -->
        <el-tab-pane
          :key="initTab3"
          label="待点名课时"
          name="becalled"
          class="becalled"
          v-if="detailsData.is_recycle == 2"
        >
          <wait-roll-call :visible="activeName === 'becalled'"></wait-roll-call>
        </el-tab-pane>
        <!-- 我的订单 -->
        <el-tab-pane
          :key="initTab4"
          label="我的订单"
          name="myorder"
          v-if="detailsData.is_recycle == 2"
        >
          <my-order :visible="activeName === 'myorder'"></my-order>
        </el-tab-pane>
        <!-- 跟进管理 -->
        <el-tab-pane label="跟进管理" name="followup">
          <follow-up-record
            :key="initTab5"
            @refreshMilestone="handleGetMilestone"
            :studentInfo="detailsData"
            :visible="activeName === 'followup'"
          ></follow-up-record>
        </el-tab-pane>
        <!-- 学员动态 -->
        <el-tab-pane label="学员动态" name="studentStatus">
          <student-status
            :update="update"
            :visible="activeName === 'studentStatus'"
          ></student-status>
        </el-tab-pane>
        <!-- 活跃度 -->
        <el-tab-pane label="学员活跃度" name="activation">
          <activation
            :student-info="{
              id: id,
              name: detailsData.name,
              mobile: detailsData.mobile,
            }"
            :visible="activeName === 'activation'"
          ></activation>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :destroy-on-close="true"
      :visible.sync="dialogVisible"
      title="学员结业"
      append-to-body
      width="500px"
      @close="
        () => {
          graduationForm = {};
        }
      "
    >
      <div>
        学员信息:
        <span>{{ graduationInfo.name }} | {{ graduationInfo.mobile }}</span>
      </div>
      <div style="margin: 15px 0" class="mwow-yellow">
        结业后，学员的所有课程全部结课、并从现有班级中移出，同时从在读学员列表移动至历史学员列表。
      </div>
      <el-form
        :model="graduationForm"
        :rules="rules"
        ref="ruleFormDom"
        label-width="75px"
        class="drawer-form"
        label-position="left"
        size="mini"
      >
        <el-form-item label="结业分类:" prop="completion_category_id">
          <el-select
            v-model.number="graduationForm.completion_category_id"
            clearable
            placeholder="请选择"
          >
            <el-option label="距离远" :value="1"></el-option>
            <el-option label="不感兴趣" :value="2"></el-option>
            <el-option label="价格贵" :value="3"></el-option>
            <el-option label="时间不合适" :value="4"></el-option>
            <el-option label="艺考" :value="5"></el-option>
            <el-option label="学业忙/工作忙" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结业原因:" prop="completion_remark">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="graduationForm.completion_remark"
            maxlength="250"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="flex form-btn">
        <div class="mwow-button-filled mini" @click="dialogVisible = false">
          取消
        </div>
        <div class="mwow-button-filled mini success" @click="sure">确定</div>
      </div>
    </el-dialog>
    <!-- 跟进弹窗 -->
    <detailsDialog
      v-if="followDialogVisible"
      type="add"
      :itemdata="id"
      @back="handleHideFollowDialog"
    />
    <!-- 还原弹窗 -->
    <recycle-dialog
      :student-ids="recycleDialogId"
      :visible.sync="recycleDialogVisible"
      @close="init"
    ></recycle-dialog>
  </div>
</template>
<script>
import {
  studentDetail,
  deldetails,
  studentCompletion,
  studentMilestoneApi,
  studentFamilyInfoApi,
} from "@/api/studyDetails";
import {
  addStudentGuardian,
  addMobileRelation,
  studentHistoryToIntentApi,
  cancelFollowStudentApi,
} from "@/api/studentManage";
import editStudentDialog from "./editStudentDialog.vue";
import integralDialog from "./integralDialog.vue";
import recoveryDialog from "./recoveryDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { PageModule } from "@/store/module/page";
import purchasedCourse from "./purchasedCourse/index.vue";
import alreadyRollCall from "./alreadyRollCall/index.vue";
import waitRollCall from "./waitRollCall/index.vue";
import myOrder from "./myOrder/index.vue";
import followUpRecord from "./followUpRecord/index.vue";
import detailsDialog from "./detailsDialog.vue";
import { UserModule } from "@/store/module/user";
import { staffCheckApi } from "@/api/makeUpLessons";
import { waitingStudentClaimConfirm } from "@/utils/student-details";
import recycleDialog from "@/view/recruit/latent/recycle/recycleDialog.vue";
import studentStatus from "./studentStatus/index.vue";
import activation from "./activation";

export default {
  name: "studyDetails",
  components: {
    integralDialog,
    recoveryDialog,
    editStudentDialog,
    purchasedCourse,
    alreadyRollCall,
    waitRollCall,
    myOrder,
    followUpRecord,
    detailsDialog,
    recycleDialog,
    studentStatus,
    activation,
  },
  data() {
    return {
      familyInfoToggleVisible: false, // 是否展示家庭成员列表展开按钮
      familyMemberList: [],
      familyMobile: "",
      dialogVisible: false,
      graduationInfo: {},
      graduationForm: {},
      id: 0,
      // activeName: "purchased", //切换字段
      activeName: "studentStatus", //切换字段
      detailsData: {
        mobile: "",
      },
      guardianRelationList: {},
      mobileRelation: {},
      milestoneLabel: {
        10: "获取",
        20: "首次联络",
        30: "首次诺访",
        35: "体验课排课",
        40: "首次到访",
        50: "首次体验",
        60: "首次购课",
        70: "首次上课",
        80: "首次续费",
      },
      milestoneList: [],
      rules: {
        completion_category_id: [
          {
            required: true,
            message: "请选择结业原因",
            trigger: "change",
          },
        ],
      },
      initTab1: 1, // 用来刷新tab页
      initTab2: 2,
      initTab3: 3,
      initTab4: 4,
      initTab5: 5,
      followDialogVisible: false,
      buttonAuth: {
        pay: false,
        follow: false,
        edit: false,
        recycle: false,
      },
      recycleDialogVisible: false,
      recycleDialogId: "",
      update: false, // 更新学员动态
      familyInfoCollapse: false,
    };
  },
  computed: {
    currentStaffID() {
      return UserModule.userInfo.staff_id;
    },
  },
  watch: {
    $route: {
      async handler(newVal, oldVal) {
        const o_id = Number(oldVal.query.id);
        const n_id = Number(newVal.query.id);
        if (o_id !== n_id) {
          this.handleGetMilestone();
          await this.getDetails(
            {
              student_id: Number(this.$route.query.id),
            },
            () => {}
          );
          this.initTab1 = new Date().getTime() + "-1";
          this.initTab2 = new Date().getTime() + "-2";
          this.initTab3 = new Date().getTime() + "-3";
          this.initTab4 = new Date().getTime() + "-4";
          this.initTab5 = new Date().getTime() + "-5";
          this.id = Number(this.$route.query.id);
        }
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    const _t = this;
    _t.id = Number(_t.$route.query.id);
    _t.getStudentGuardian();
    _t.getMobileRelation();
    _t.getDetails(
      {
        student_id: _t.id,
      },
      () => {}
    );
    const cache = PageModule.pageInfo.studyDetails;
    if (_t.$route.query.tab) {
      this.activeName = _t.$route.query.tab;
    } else if (cache.tab) {
      this.activeName = cache.tab;
    } else {
      this.activeName = "purchased";
      PageModule.SET_PAGE_INFO({
        name: "studyDetails",
        key: "tab",
        value: "purchased",
      });
    }
    this.handleGetMilestone();
    // 获取家庭信息
    studentFamilyInfoApi({
      student_id: _t.id,
    }).then((res) => {
      this.familyMemberList = res.data.student_list;
      this.familyMobile = res.data.mobile;
    });
    // 判断右上角按钮权限
    staffCheckApi({
      api_path: [
        "/api/v1/student/edit",
        "/api/v1/student/follow/add",
        "/api/v1/student/recycle",
        "/api/v1/order/create",
      ],
    }).then((res) => {
      if (res.data["/api/v1/student/edit"]) {
        this.buttonAuth.edit = true;
      }
      if (res.data["/api/v1/student/follow/add"]) {
        this.buttonAuth.follow = true;
      }
      if (res.data["/api/v1/student/recycle"]) {
        this.buttonAuth.recycle = true;
      }
      if (res.data["/api/v1/order/create"]) {
        this.buttonAuth.pay = true;
      }
    });
    // 监听页面resize，调整家庭模块展开按钮
    window.addEventListener("resize", this.handleShowFamilyToggle);
  },
  mounted() {
    if (
      this.$route.query.tab === "activation" &&
      this.$route.query.from === "student_statistics_activation"
    ) {
      setTimeout(() => {
        console.log("scroll");
        document.getElementById("layout-content").scrollTo(0, 1000);
      }, 200);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleShowFamilyToggle);
  },
  methods: {
    handleShowFamilyToggle(val) {
      // 右边里程碑与左边详情高度统一
      if (val) {
        let blockLeft = document.querySelector(".block-left .student-info");
        let blockRight = document.querySelector(".block-right");
        blockRight.style.height = blockLeft.clientHeight + 108 + "px";
      }
      let el = this.$refs.familyInfoEl;
      let allName = document.querySelectorAll(".name-wrap .name");
      let allNameWidth = 0;
      // 异步更新
      setTimeout(() => {
        allName.forEach((item) => {
          allNameWidth += Number(item.clientWidth) + 15;
        });
        // 控制第一次渲染，只有超过 41 才展示
        if (val === "first") {
          if (el.clientHeight > 41) {
            this.familyInfoToggleVisible = true;
          }
        } else {
          //  超过 41，优先判断，父级宽度 与 所有子级宽度总和之间的关系
          if (el.clientWidth > allNameWidth) {
            this.familyInfoToggleVisible = false;
          } else {
            this.familyInfoToggleVisible = true;
          }
        }
      }, 10);
    },
    init() {
      this.update = !this.update;
      this.getDetails(
        {
          student_id: this.id,
        },
        () => {}
      );
    },
    sure() {
      this.$refs["ruleFormDom"].validate((valid) => {
        if (valid) {
          const data = {
            student_id: Number(this.id),
            completion_category_id: this.graduationForm.completion_category_id,
            force: 0,
          };
          if (this.graduationForm.completion_remark) {
            data.completion_remark = this.graduationForm.completion_remark;
          }
          studentCompletion(data).then((res) => {
            if (res.error_code == 0) {
              this.activeName = "purchased";
              this.getDetails({ student_id: this.id }, () => {});
              this.$message({
                type: "success",
                message: "结业成功",
              });
              this.dialogVisible = false;
            }
            // 有超上课时
            if (res.error_code == 21009006) {
              this.$confirm(
                `${res.message}`,
                `结业 - ${this.graduationInfo.name}`,
                {
                  confirmButtonText: "确定",
                  confirmButtonClass: "mwow-button-filled success mini",
                  cancelButtonText: "取消",
                  cancelButtonClass: "mwow-button-filled mini",
                  type: "warning",
                }
              )
                .then(() => {
                  data.force = 1;
                  studentCompletion(data).then((res) => {
                    if (res.error_code == 0) {
                      this.activeName = "purchased";
                      this.getDetails({ student_id: this.id }, () => {});
                      this.$message({
                        type: "success",
                        message: "结业成功",
                      });
                      this.dialogVisible = false;
                    }
                  });
                })
                .catch(() => {});
              return;
            }
          });
        }
      });
    },
    handleGetMilestone() {
      const id = Number(this.$route.query.id);
      studentMilestoneApi({
        student_id: id,
      }).then((res) => {
        this.milestoneList = res.data.list;
      });
      this.update = !this.update;
    },
    convertIntention(val) {
      this.$confirm(
        "确定要转回意向学员，此操作过程不能撤销，确定后将移动至意向学员列表，且学员的历史数据记录会保留，但将回到 “待分配” 阶段，确定要转回意向学员？",
        `转回意向 - ${val.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          studentHistoryToIntentApi({
            student_id: val.student_id,
          }).then((res) => {
            if (res.error_code === 0) {
              this.$message({
                message: "操作完成",
                type: "success",
              });
              this.$router.push({
                name: "latent",
              });
            }
          });
        })
        .catch(() => {});
    },
    handleRecover() {
      this.recycleDialogId = [this.id];
      this.recycleDialogVisible = true;
    },
    getStudentGuardian() {
      addStudentGuardian().then((res) => {
        const obj = {};
        res.data.list.forEach((a) => {
          obj[a.key] = a.value;
        });
        this.guardianRelationList = obj;
      });
    },
    getMobileRelation() {
      addMobileRelation().then((res) => {
        const obj = {};
        res.data.list.forEach((a) => {
          obj[a.key] = a.value;
        });
        this.mobileRelation = obj;
      });
    },
    recoveryPost() {
      this.getDetails(
        {
          student_id: this.id,
        },
        () => {}
      );
      this.update = !this.update;
    },
    // 时间格式化
    dateYearMonthDay(unixtime) {
      const dateTime = new Date(unixtime);
      const year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      if (month > 0 && month < 10) {
        month = "0" + month;
      }
      let day = dateTime.getDate();
      if (day > 0 && day < 10) {
        day = "0" + day;
      }
      const timeSpanStr = year + "-" + month + "-" + day;
      return timeSpanStr;
    },
    addClass(e) {
      const _t = this;
      _t.$router.push({ name: "classManage" });
    },
    // 学员详情缴费
    clickrenew() {
      const _t = this;
      if (!this.buttonAuth.pay) {
        return false;
      }
      if (
        !this.detailsData.follow_staff_id &&
        this.detailsData.status === 1 &&
        this.detailsData.is_potential === 1 &&
        this.$route.query.from === "waiting_student"
      ) {
        waitingStudentClaimConfirm({
          studentName: this.detailsData.name,
          studentID: Number(this.detailsData.student_id),
          claimSuccessCallback: () => {
            _t.$router.push({
              name: "buyCourseConfirm",
              query: { id: _t.id },
            });
          },
        });
      } else {
        if (_t.detailsData.status == 1) {
          _t.$confirm(
            "意向学员在完成缴费后，会自动转化为在读学员，同时跟进状态自动变为已成交，确定前往缴费？",
            `缴费 - ${_t.detailsData.name}`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
            }
          )
            .then(() => {
              _t.$router.push({
                name: "buyCourseConfirm",
                query: { id: _t.id },
              });
            })
            .catch(() => {});
          return;
        }
        if (_t.detailsData.status == 3) {
          _t.$confirm(
            "历史学员在完成缴费后，状态将自动转为在读，并移动至在读学员列表。确定要缴费？",
            `缴费 - ${_t.detailsData.name}`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
            }
          )
            .then(() => {
              _t.$router.push({
                name: "buyCourseConfirm",
                query: { id: _t.id },
              });
            })
            .catch(() => {});
          return;
        }
        _t.$router.push({
          name: "buyCourseConfirm",
          query: { id: _t.id },
        });
      }
    },
    lookDetails(e) {
      const _t = this;
      _t.$router.push({
        name: "orderManageDetail",
        query: {
          id: String(e.order_id),
        },
      });
    },
    getdate(a, b) {
      return dateFormat(a, b);
    },
    // 结业
    poststudentCompletion(item) {
      this.graduationInfo = item;
      this.dialogVisible = true;
    },
    getDetails(id, cd) {
      const _t = this;
      if (!id) {
        id = { student_id: (_t.id = Number(_t.$route.query.id)) };
      }
      studentDetail(id).then((res) => {
        if (res.error_code == 0) {
          res.data.birthdaydate =
            res.data.birthday != 0
              ? _t.dateYearMonthDay(Number(res.data.birthday + "000"))
              : "-";
          _t.detailsData = res.data;
          if (cd) {
            cd();
          }
          const today = new Date().getTime();
          if (res.data.age === 0) {
            if (res.data.birthday !== 0) {
              const severalMonths = today - res.data.birthday * 1000;
              res.data.age = new Date(severalMonths).getMonth() + "个月";
            } else {
              res.data.age = "-";
            }
          } else {
            res.data.age = res.data.age + "岁";
          }
          this.handleShowFamilyToggle("first");
        }
      });
    },
    // 学员详情-删除操作
    delDetails() {
      const _t = this;
      _t.$confirm(
        "删除后，学员基本信息等数据将被清除，此操作不能撤销。",
        `删除 - ${_t.detailsData.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          deldetails({ student_ids: [_t.id] }).then((res) => {
            if (res.error_code == 0) {
              if (res.data.check === false) {
                _t.$confirm(
                  "此学员已有订单记录，如需删除请废除学员所有订单后，再进行删除。",
                  `无法删除 - ${_t.detailsData.name}`,
                  {
                    confirmButtonText: "预览订单",
                    confirmButtonClass: "mwow-button-filled success mini",
                    cancelButtonText: "取消",
                    cancelButtonClass: "mwow-button-filled mini",
                    iconClass: "mwow-icon-error",
                  }
                )
                  .then(() => {
                    _t.activeName = "myorder";
                  })
                  .catch(() => {});
              } else {
                _t.goBack();
              }
            }
          });
        })
        .catch(() => {});
    },
    goBack() {
      this.$router.go(-1);
    },
    toStudentDetail(id) {
      this.$router.replace({
        name: "studyDetails",
        query: { id: String(id) },
      });
    },
    handleTabChange() {
      const _t = this;
      PageModule.SET_PAGE_INFO({
        name: "studyDetails",
        key: "tab",
        value: _t.activeName,
      });
    },
    handleBack() {
      if (this.$route.query.from === "buy_order_details") {
        this.$router.go(-4);
      } else if (this.$route.query.from === "studentBirthday") {
        // 学员生日
        this.$router.push({
          name: "studentManage",
          query: {
            to: "studentBirthday",
            from: "studentdetails",
          },
        });
      } else {
        this.$router.go(-1);
      }
    },
    followContent() {
      if (!this.buttonAuth.follow) {
        return false;
      }
      if (
        !this.detailsData.follow_staff_id &&
        this.detailsData.status === 1 &&
        this.detailsData.is_potential === 1 &&
        this.$route.query.from === "waiting_student"
      ) {
        waitingStudentClaimConfirm({
          studentName: this.detailsData.name,
          studentID: Number(this.detailsData.student_id),
          claimSuccessCallback: () => {
            this.followDialogVisible = true;
          },
        });
      } else {
        this.followDialogVisible = true;
      }
    },
    handleHideFollowDialog() {
      this.followDialogVisible = false;
      // 重新获取跟进管理数据
      if (this.activeName === "followup") {
        this.initTab5 = new Date().getTime() + "-5";
      }
      this.update = !this.update;
    },
    handleCancelFollow() {
      this.$confirm(
        `确定对${this.detailsData.name}学员放弃学员跟进吗？放弃后你将不再作为该学员的课程顾问`,
        `放弃学员`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          cancelFollowStudentApi({ student_id: this.id }).then((res) => {
            this.$message({
              type: "success",
              message: "放弃成功",
            });
            this.getDetails({
              student_id: this.id,
            });
          });
        })
        .catch(() => {});
    },
    handleToggleFamilyInfo() {
      this.familyInfoCollapse = !this.familyInfoCollapse;
    },
  },
};
</script>

<style scoped lang="scss">
.student-detail-container {
  .mwow-detail-header {
    background-color: #fff;
    border: 1px solid #e7e8ea;
    border-radius: 10px;
    padding: 0 15px;
    margin-bottom: 18px;
  }
  .student-info-block {
    display: flex;
    .block-left {
      background-color: #fff;
      border: 1px solid #e7e8ea;
      border-radius: 10px;
      flex: 1;
      margin-right: 16px;
      padding: 0 15px 0 25px;
      .family-info {
        border-bottom: 1px solid #e7e8ea;
        padding: 13px 20px 0 16px;
        position: relative;
        margin-bottom: 21px;
        height: auto;
        display: flex;
        &.collapse {
          height: 41px;
          overflow: hidden;
        }
        .mobile {
          font-size: 15px;
          display: inline-block;
          color: #5c5d5e;
          line-height: 28px;
          margin: 0 30px 13px 0;
        }
        .name-wrap {
          flex: 1;
          .name {
            display: inline-block;
            padding: 0 14px;
            line-height: 28px;
            background-color: #f3f4f5;
            margin-right: 15px;
            font-size: 14px;
            color: #5c5d5e;
            cursor: pointer;
            border-radius: 4px;
            margin-bottom: 13px;
            white-space: nowrap;
            &.active {
              background-color: #45b13b;
              color: #fff;
            }
          }
        }
        .more {
          color: #5c5d5e;
          background-color: #e7e8ea;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          border-radius: 50%;
          display: inline-block;
          position: absolute;
          top: 18px;
          right: 0;
          cursor: pointer;
        }
      }
      .student-info {
        padding-bottom: 32px;
        .main-wrap {
          display: flex;
          background-color: #f6fafc;
          border-radius: 10px;
          padding: 12px;
          position: relative;
          .avatar-wrap {
            width: 70px;
            margin-right: 20px;
            .avatar {
              margin-bottom: 14px;
            }
            .tag {
              text-align: center;
            }
          }
          .form {
            flex: 1;
            padding: 12px 82px 12px 0;
          }
        }
        .other-wrap {
          padding: 0 22px 0 103px;
          margin-top: 24px;
        }
        .row {
          display: flex;
          margin-bottom: 20px;
          &:last-child {
            margin-block: 0;
          }
          .item {
            flex: 1;
            color: #5c5d5e;
            font-size: 14px;
            line-height: 14px;
            .label {
              font-weight: bold;
            }
            .line {
              height: 14px;
              border-right: 1px solid #e7e8ea;
              display: inline-block;
              vertical-align: top;
              margin: 0 10px;
            }
          }
        }
      }
    }
    .block-right {
      width: 250px;
      background-color: #fff;
      border: 1px solid #e7e8ea;
      border-radius: 10px;
      padding: 20px;
      .title {
        font-size: 16px;
        line-height: 20px;
        color: #5c5d5e;
        margin-bottom: 22px;
        font-weight: bold;
      }
      .list {
        padding: 0px 24px;
        .step {
          display: flex;
          margin-bottom: 30px;
          position: relative;
          align-items: center;
          &.active {
            .text-wrap {
              .text {
                color: #5c5d5e;
              }
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
          .icon {
            width: 18px;
            height: 18px;
            position: relative;
            margin-right: 12px;
          }
          .line {
            border-right: 1px solid #e1e4e6;
            position: absolute;
            top: -26px;
            left: 8px;
            height: 20px;
            &.active {
              border-color: #45b13b;
            }
          }
          .text-wrap {
            width: 100%;
            .text {
              font-size: 13px;
              line-height: 18px;
              color: #c2c3c4;
              &.bold {
                font-weight: bold;
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
  .tabs-wrap {
    margin-top: 12px;
    min-height: 183px;
    padding: 5px 20px;
    border-radius: 10px;
    border: 1px solid rgba(231, 232, 234, 1);
    background-color: #fff;
    .el-tabs {
      .el-tabs__header {
        margin: 0 0 20px !important;
      }
    }
    /deep/ .el-tabs__nav {
      display: flex;
    }
    .rollcall {
      .footerTabs {
        margin-bottom: 12px;
      }
      .purchasedLable {
        color: #5c5d5e;
        background: #fff7e9;
      }
    }
    .el-form .el-form-item__label {
      text-align: right;
    }
    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
      margin-bottom: 12px !important;
      margin-right: 50px !important;
    }
    .light {
      width: 1px;
      height: 16px;
      background-color: #dcdfe6;
      display: inline-block;
      margin: 0 20px;
    }
  }
}
/deep/.drawer-form {
  .el-form-item {
    .el-form-item__label {
      text-align: right !important;
    }
  }
}
.form-btn {
  justify-content: flex-end !important;
  div {
    margin-left: 20px;
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

@media screen and (max-width: 1300px) {
  .student-info-block {
    .block-right {
      width: 150px !important;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        width: 4px;
        background: none;
      }
      &::-webkit-scrollbar-thumb {
        width: 4px;
        background: #d8d8d8;
      }
      .list {
        .text-wrap {
          flex-direction: column;
        }
      }
    }
  }
}
</style>
